import PropTypes from 'prop-types'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { WebinarContainerComponent } from '..'
import { WebinarAppStateProvider } from '../../providers/WebinarAppStateProvider'

const WebinarApp = () => (
  <WebinarAppStateProvider>
    <WebinarContainerComponent />
  </WebinarAppStateProvider>
)

const WebinarIndexComponent = (props) => {
  const {
    match: { path },
  } = props

  return (
    <Switch>
      <Route path={`${path}/producer/:live_id`}>
        <WebinarApp />
      </Route>
      <Route path={`${path}/presenter/:live_id/:presenter_token`}>
        <WebinarApp />
      </Route>
    </Switch>
  )
}

WebinarIndexComponent.propTypes = {
  match: PropTypes.object,
}

export default WebinarIndexComponent
